// Consentimento de cookies (LGPD art. 7º, I e art. 8º).
//
// Só o cookie de preferência e o login são essenciais. Análise de uso (PostHog)
// carrega apenas depois do "Aceitar" e para na hora em que a pessoa revoga.
// O cookie de preferência vale para oplyx.com.br e app.oplyx.com.br juntos.

const COOKIE = "oplyx_consent";
const VERSION = 1;
const MAX_AGE_DAYS = 180;          // pergunta de novo a cada 6 meses
export const OPEN_PREFERENCES_EVENT = "oplyx:cookie-preferences";
const CHANGE_EVENT = "oplyx:consent-changed";

const POSTHOG_KEY = "phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs";
const POSTHOG_HOST = "https://us.i.posthog.com";

function cookieDomain() {
  const h = window.location.hostname;
  return h === "oplyx.com.br" || h.endsWith(".oplyx.com.br") ? "; domain=.oplyx.com.br" : "";
}

export function isLandingHost() {
  const h = window.location.hostname;
  return h === "oplyx.com.br" || h === "www.oplyx.com.br";
}

export function getConsent() {
  try {
    const m = document.cookie.match(/(?:^|;\s*)oplyx_consent=([^;]*)/);
    if (!m) return null;
    const c = JSON.parse(decodeURIComponent(m[1]));
    return c && c.v === VERSION ? c : null;
  } catch {
    return null;
  }
}

export function setConsent({ analytics }) {
  const c = { v: VERSION, analytics: !!analytics, at: new Date().toISOString() };
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${COOKIE}=${encodeURIComponent(JSON.stringify(c))}; path=/; max-age=${MAX_AGE_DAYS * 86400}; SameSite=Lax${cookieDomain()}${secure}`;
  applyConsent(c);
  window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: c }));
  return c;
}

export function openCookiePreferences() {
  window.dispatchEvent(new Event(OPEN_PREFERENCES_EVENT));
}

export function onConsentChange(fn) {
  const h = (e) => fn(e.detail);
  window.addEventListener(CHANGE_EVENT, h);
  return () => window.removeEventListener(CHANGE_EVENT, h);
}

// ─── PostHog ────────────────────────────────────────────────────────────────

let loaded = false;

function loadPosthog() {
  if (loaded) {
    window.posthog?.opt_in_capturing?.();
    return;
  }
  loaded = true;
  /* eslint-disable */
  // Snippet oficial do PostHog: cria o stub e carrega array.js de forma assíncrona.
  !(function (t, e) {
    var o, n, p, r;
    e.__SV || ((window.posthog = e), (e._i = []), (e.init = function (i, s, a) {
      function g(t, e) { var o = e.split("."); 2 == o.length && ((t = t[o[0]]), (e = o[1])), (t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); }); }
      ((p = t.createElement("script")).type = "text/javascript"), (p.crossOrigin = "anonymous"), (p.async = !0),
      (p.src = s.api_host.replace(".i.posthog.com", "-assets.i.posthog.com") + "/static/array.js"),
      (r = t.getElementsByTagName("script")[0]).parentNode.insertBefore(p, r);
      var u = e;
      for (void 0 !== a ? (u = e[a] = []) : (a = "posthog"), u.people = u.people || [],
        u.toString = function (t) { var e = "posthog"; return "posthog" !== a && (e += "." + a), t || (e += " (stub)"), e; },
        u.people.toString = function () { return u.toString(1) + ".people (stub)"; },
        o = "init capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags onFeatureFlags onSessionId identify setPersonProperties group resetGroups reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing debug".split(" "),
        n = 0; n < o.length; n++) g(u, o[n]);
      e._i.push([i, s, a]);
    }), (e.__SV = 1));
  })(document, window.posthog || []);
  /* eslint-enable */

  // No app logado as telas mostram faturamento, clientes e CPF: sem gravação de
  // sessão e sem texto ou atributo de elemento nos eventos. Na landing (página
  // pública) a gravação fica, com todo campo digitado mascarado.
  const app = !isLandingHost();
  window.posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: "identified_only",
    mask_all_text: app,
    mask_all_element_attributes: app,
    disable_session_recording: app,
    session_recording: { maskAllInputs: true, maskTextSelector: "[data-private]" },
  });
}

function clearPosthogStorage() {
  try {
    Object.keys(localStorage).filter((k) => k.startsWith("ph_") || k.startsWith("__ph")).forEach((k) => localStorage.removeItem(k));
    Object.keys(sessionStorage).filter((k) => k.startsWith("ph_") || k.startsWith("__ph")).forEach((k) => sessionStorage.removeItem(k));
  } catch { /* armazenamento bloqueado */ }
  document.cookie.split(";").map((c) => c.split("=")[0].trim()).filter((n) => n.startsWith("ph_")).forEach((n) => {
    document.cookie = `${n}=; path=/; max-age=0`;
    document.cookie = `${n}=; path=/; max-age=0${cookieDomain()}`;
  });
}

export function applyConsent(c = getConsent()) {
  if (c?.analytics) {
    loadPosthog();
  } else if (loaded) {
    window.posthog?.opt_out_capturing?.();
    window.posthog?.stopSessionRecording?.();
    clearPosthogStorage();
  } else {
    clearPosthogStorage();
  }
}
